import { useSelector } from "react-redux";

export function useCurrentRoute() {
  const currentRoute = useSelector(({ currentRoute }) => {
    if (currentRoute.url) {
      return currentRoute;
    }

    return {
      name: document.title,
      url: window.location.href,
      path: window.location.pathname,
    };
  });

  return currentRoute;
}
